import React from 'react';
import { Box } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

/**
 * Reusable Bar Chart component for sales performance
 * @param {Array} data - Chart data with timeSlot, dineIn, pickUp properties
 * @param {Object} customStyles - Optional custom styling for the container
 */
const SalesBarChart = ({ data, customStyles = {} }) => {
  return (
    <Box sx={{ width: "100%", overflowX: "auto", ...customStyles }}>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
        >
          <defs>
            <linearGradient id="dineInGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#1976d2" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#1976d2" stopOpacity={0.3} />
            </linearGradient>
            <linearGradient id="pickUpGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#00897b" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#00897b" stopOpacity={0.3} />
            </linearGradient>
            <linearGradient id="deliveryGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#6a1b9a" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#6a1b9a" stopOpacity={0.3} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis
            dataKey="timeSlot"
            angle={-45}
            textAnchor="end"
            height={80}
            tick={{ fontSize: 12 }}
          />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip
            formatter={(value) => [`₹${value.toLocaleString()}`, '']}
            contentStyle={{
              backgroundColor: "#fff",
              border: "1px solid #e0e0e0",
              borderRadius: 12,
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              fontSize: "14px",
            }}
            labelFormatter={(label) => `Time Slot: ${label}`}
          />
          <Legend wrapperStyle={{ paddingTop: '20px' }} />
          <Bar
            dataKey="dineIn"
            stackId="a"
            fill="url(#dineInGradient)"
            name="Dine In"
            radius={[8, 8, 0, 0]}
            animationDuration={1500}
            animationBegin={0}
          />
          <Bar
            dataKey="pickUp"
            stackId="a"
            fill="url(#pickUpGradient)"
            name="Pick Up"
            radius={[0, 0, 8, 8]}
            animationDuration={1500}
            animationBegin={300}
          />
          <Bar
            dataKey="delivery"
            stackId="a"
            fill="url(#deliveryGradient)"
            name="Delivery"
            radius={[0, 0, 8, 8]}
            animationDuration={1500}
            animationBegin={600}
          />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default SalesBarChart;
